import { combineReducers } from 'redux';
import categories from './categories';
import dictionaries from './dictionaries';
import ui from './ui';
import user from './user';
import catalog from './catalog';
import cart from './cart';
import favorites from './favorites';
import auth from './auth';
import profile from './profile';
import loyalty from './loyalty';
import recipeCart from './recipe-cart';
import offers from './offers';
import drugstores from './drugstores';
import drugstore_cart from './drugstore_cart';

export default combineReducers({
  dictionaries,
  ui,
  user,
  catalog,
  cart,
  favorites,
  auth,
  profile,
  loyalty,
  recipeCart,
  offers,
  drugstores,
  drugstore_cart,
  categories,
});
